import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import Downshift from 'downshift';
import React__default from 'react';
import { FloatingMenu } from '../FloatingMenu/FloatingMenu.es.js';
import { TypeaheadInput } from './TypeaheadInput.es.js';

const root = "_root_aafji_1";
const styles = {
	root: root
};

const dedupeAndTrimWhitespace = (query) => query.replace(/(\s+)/g, " ").trim();
const defaultFilterItems = (inputValue, items, getLabelForItem, showEmptyList = false) => {
  if (showEmptyList || !inputValue) {
    return items;
  }
  const lowerCaseInput = inputValue.toLowerCase();
  return items.filter((item) => {
    return getLabelForItem(item).toLowerCase().includes(dedupeAndTrimWhitespace(lowerCaseInput));
  });
};
class Typeahead extends React__default.Component {
  constructor() {
    super(...arguments);
    this.itemToString = (item) => {
      return item ? this.props.getLabelForItem(item) : "";
    };
    this.stateReducer = (state, changes) => {
      if (this.props.keepInputValueOnBlur && (changes.type === Downshift.stateChangeTypes.blurInput || changes.type === Downshift.stateChangeTypes.mouseUp)) {
        return Object.assign(Object.assign({}, changes), { inputValue: state.inputValue });
      }
      return changes;
    };
  }
  render() {
    const { props } = this;
    return React__default.createElement(Downshift, { id: props.id, initialSelectedItem: props.selectedItem || props.initialSelectedItem, inputId: props.inputId, inputValue: props.inputValue, itemToString: this.itemToString, labelId: props.labelId, onChange: props.onChange, onInputValueChange: props.onInputValueChange, selectedItem: props.selectedItem, stateReducer: this.stateReducer }, ({
      clearSelection,
      getInputProps,
      getItemProps,
      getMenuProps,
      getRootProps,
      highlightedIndex,
      // This does exist, it's just not in the typings.
      // We're using an old version of downshift
      // @ts-ignore
      inputId,
      inputValue,
      isOpen,
      openMenu,
      selectedItem
    }) => {
      if (props.setClearSelection) {
        props.setClearSelection(clearSelection);
      }
      const ariaLabelledBy = props.labelId || null;
      const _a = getRootProps({
        // @ts-ignore
        "aria-labelledby": ariaLabelledBy,
        refKey: "innerRef"
      }, { suppressRefError: true }), { innerRef } = _a, rootProps = __rest(_a, ["innerRef"]);
      const filteredItems = props.filterItems(inputValue, props.items, props.getLabelForItem, props.showEmptyList || false);
      const showMenu = isOpen && filteredItems.length > 0;
      const isErrored = props.showErrorOnNoResults && inputValue && filteredItems.length === 0 || props.isErrored;
      return React__default.createElement(
        "div",
        Object.assign({}, rootProps, { className: styles.root, ref: innerRef, "data-zds": true }),
        React__default.createElement(TypeaheadInput, { "aria-label": props["aria-label"], "aria-labelledby": ariaLabelledBy, autoComplete: props.autoComplete, clearSelection, disabledText: props.disabledText, getInputProps, getLabelForItem: props.getLabelForItem, iconEndName: props.iconEndName, inputValue, isBusy: props.isBusy, isDisabled: props.isDisabled, isErrored: !!isErrored, onFocus: props.openOnFocus ? openMenu : void 0, onKeyDown: props.onKeyDown, placeholder: props.placeholder, ref: props.inputRef, renderIcon: props.renderIcon, selectedItem, size: props.size, onBlur: props.onBlur }),
        showMenu && props.renderFloatingMenu({
          "aria-label": props.menuAriaLabel,
          getItemProps,
          getKeyForItem: props.getKeyForItem,
          getLabelForItem: props.getLabelForItem,
          getMenuProps,
          highlightedIndex,
          items: filteredItems,
          renderIcon: props.renderIcon
        })
      );
    });
  }
}
Typeahead.defaultProps = {
  filterItems: defaultFilterItems,
  isDisabled: false,
  openOnFocus: false,
  renderFloatingMenu: (props) => React__default.createElement(FloatingMenu, Object.assign({}, props)),
  showEmptyList: false,
  showErrorOnNoResults: false
};

export { Typeahead, Typeahead as default };
//# sourceMappingURL=Typeahead.es.js.map
